import { useContext, useEffect, useState } from 'react';
import AccountPickerContext from '../contexts/AccountPickerContext';

const useTextCardContent = (id: string) => {
  const [textContent, setTextContent] = useState<string>('');
  const [isCenterAlign, setIsCenterAlign] = useState<boolean | undefined>();
  // The metrics (and their dates and filters) Studio saved for the text's
  // {placeholders}
  const [studio, setStudio] = useState<Studio.TextStudioSettings>();
  // Studio only: Markdown rather than rich text, and the tile's colours
  const [format, setFormat] = useState<Studio.TextFormat>();
  const [background, setBackground] = useState<Studio.TextBackground>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { accountRef } = useContext(AccountPickerContext);

  useEffect(() => {
    if (process.env.NODE_ENV === 'test') {
      return;
    }

    const listener = accountRef
      .collection('textCardContents')
      .doc(id)
      .onSnapshot((s) => {
        const d = s.data();
        if (d) {
          setTextContent(d.textContent);
          setIsCenterAlign(!!d.isCenterAlign);
          setStudio(d.studio);
          setFormat(d.format);
          setBackground(d.background);
          setIsLoading(false);
        }
      });

    return () => {
      listener();
    };
  }, [accountRef, id]);

  return {
    text: textContent,
    isCenterAlign,
    studio,
    format,
    background,
    isLoading,
  };
};

export default useTextCardContent;
